
/* injects from baggage-loader */
require('./style.scss');

import React, { useState, useEffect } from "react";
import moment from "moment";

import Zergling from "../../../helpers/zergling";
import MultiplesItem from "./pieces/multiplesItem";

const getDataWithColumns = (data, columnCount) => {
    const columns = [];

    for (var i = 0; i < columnCount; i++)
        columns[i] = data.filter((_, index) => (index - i) % columnCount === 0);

    return columns;
};

const PredefinedMultiples = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const timeoutIds = [];

        (async () => {
            const { details } = await Zergling.get({}, 'get_predefined_multiples');

            const columns = details
                .filter(multiple => moment(new Date()).isBefore(moment(multiple.ExpiresAt)))
                .sort((a, b) => a.order - b.order)

            columns.forEach(multiple => {
                const now = moment.now()
                const expiresAt = moment(multiple.ExpiresAt)
                const durationInMiliseconds = moment.duration(expiresAt.diff(now)).asMilliseconds();

                timeoutIds.push(setTimeout(() => {
                    setData(data => data.filter(item => item.Id !== multiple.Id))
                }, durationInMiliseconds))
            });

            setData(columns);
        })();

        return () => timeoutIds.forEach(clearTimeout)
    }, []);

    return <div className="predefined-multiples select-sport-contain-m">
        {/* {data?.map((column, index) => <div key={index} className="multiples-column">
            {column.map(multiple => <MultiplesItem
                key={multiple.Id}
                multiple={multiple}
                bonusPercent={multiple.BonusPercent}
            />)} */}
            {data?.map((multiple) => <MultiplesItem
                key={multiple.Id}
                multiple={multiple}
                bonusPercent={multiple.BonusPercent}
            />
            )}
    </div>
};

export default PredefinedMultiples;